import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { TextAreaEnum } from '@panaya/ui/p-field-text';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder } from '@angular/forms';
import { FeedbackIssuesValues } from '@panaya/ui/p-feedback';
import { PDialogFooterBtnActionType, PDialogFooterBtnConfig } from '../p-dialog-footer-btn-config.interface';

@Component({
    selector: 'p-feedback-dialog',
    template: `
        <p-dialog-container>
            <p-dialog-header title="{{ 'Correction.generalTab.feedbackDialog.header' | translate }}"></p-dialog-header>
            <div class="p-dialog-content">
                <div class="p-paragraph-1 p-tpgr-bold msg">{{ 'Correction.generalTab.feedbackDialog.message' | translate }}</div>
                <div [formGroup]="form" pLabelAligner=".p-field-label">
                    <p-field-single-select
                        [label]="'Correction.generalTab.feedbackDialog.describeIssue' | translate"
                        [list]="feedbackIssuesEnum"
                        [emptyOption]="{ id: null, name: ('Messages.select_value' | translate) }"
                        formControlName="issue"
                    ></p-field-single-select>
                    <p-field-text
                        class="feedback-review"
                        [label]="'Correction.generalTab.feedbackDialog.writeReview' | translate"
                        [placeholder]="'Correction.generalTab.feedbackDialog.reviewPlaceholder' | translate"
                        [isMultiline]="true"
                        [size]="textAreaSize"
                        formControlName="review"
                    ></p-field-text>
                </div>
            </div>
            <p-dialog-footer [btnConfig]="footerConfig"></p-dialog-footer>
        </p-dialog-container>
    `,
    styleUrls: ['./p-feedback-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PFeedbackDialogComponent {
    textAreaSize = TextAreaEnum.Medium;
    feedbackIssuesEnum = FeedbackIssuesValues;

    form = this.fb.group({
        issue: [],
        review: []
    });

    constructor(
        private readonly dialogRef: MatDialogRef<PFeedbackDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { description: string },
        private readonly fb: UntypedFormBuilder
    ) {}

    get footerConfig(): PDialogFooterBtnConfig[] {
        return [
            {
                text: 'Actions.submit',
                disabled: !this.form.dirty,
                click: (): void => this.submit()
            },
            {
                text: 'Correction.generalTab.feedbackDialog.laterButton',
                type: PDialogFooterBtnActionType.Close
            }
        ];
    }

    private submit(): void {
        this.dialogRef.close(this.form.value);
    }
}
